import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Countdown from "react-countdown";
import NumberFormat from "react-number-format";
import {
  selectMemberInfo,
  saveContactInfos,
  reSendValidateCodeContactInfos,
  clearContactInfoRedirect,
} from "../../../state/ducks/member/index";
import EminevimLoading from "../shared/EminevimLoading";
import LoginPageAlert from "../Login/LoginPageAlert";

const maskEmail = (email) => {
  if (!email || typeof email !== "string") return "**********";
  const atIndex = email.indexOf("@");
  if (atIndex <= 0) return `${email.substring(0, Math.min(3, email.length))}**********`;
  return `${email.substring(0, 3)}**********${email.substring(atIndex)}`;
};

const maskPhone = (phone) => {
  if (!phone || phone.length < 5) return "**********";
  return `${phone.substring(0, 3)}******${phone.substring(phone.length - 2)}`;
};

class UpdateContactInfo extends Component {
  state = {
    bilgi: this.props.member?.bilgi,
    iletisimTur: this.props.match?.params?.id,
    kod: "",
    shouldAnimateCard: false,
    isProcessing: false,
    isTimerExpired: false,
    canResend: false,
    formAlert: null,
  };

  componentDidMount() {
    this.props.clearRedirect();
    this.syncTimerState();
    this.setState({ shouldAnimateCard: true });
    window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.member?.countDate !== this.props.member?.countDate) {
      this.setState({ kod: "", isTimerExpired: false, canResend: false });
    }

    if (prevProps.member?.bilgi !== this.props.member?.bilgi && this.props.member?.bilgi) {
      this.setState({ bilgi: this.props.member.bilgi });
    }
  }

  syncTimerState = () => {
    const { member } = this.props;
    const expired = !member?.countDate || member.countDate + 180000 < Date.now();
    this.setState({
      isTimerExpired: expired,
      canResend: expired,
    });
  };

  handleTimerStart = () => {
    this.setState({ isTimerExpired: false, canResend: false });
  };

  handleTimerComplete = () => {
    this.setState({ isTimerExpired: true, canResend: true });
  };

  resetCounter = () => {
    const { bilgi, iletisimTur } = this.state;
    this.setState({ isProcessing: true });
    Promise.resolve(this.props.reSendValidateCode(bilgi, iletisimTur)).finally(() => {
      this.setState({ isProcessing: false });
    });
  };

  submit = (event) => {
    event.preventDefault();
    const { bilgi, iletisimTur, kod, isTimerExpired, isProcessing } = this.state;

    if (isTimerExpired || isProcessing) {
      return;
    }

    this.setState({ isProcessing: true, formAlert: null });
    Promise.resolve(this.props.saveContactInfo(bilgi, iletisimTur, kod))
      .then((result) => {
        if (result?.success) {
          this.props.history.push({
            pathname: "/Home/AccountInfo",
            state: {
              profileAlert: {
                type: "success",
                messages: ["Bilgileriniz başarıyla kaydedilmiştir."],
              },
            },
          });
          return;
        }

        if (result && result.success === false) {
          this.setState({
            formAlert: {
              type: "error",
              messages: [result.message],
            },
          });
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  clearFormAlert = () => {
    this.setState({ formAlert: null });
  };

  renderVerificationSteps = (firstStepLabel) => (
    <div className="t-controlContactInfo-steps">
      <div className="t-controlContactInfo-step t-controlContactInfo-step--completed">
        <span className="t-controlContactInfo-stepNumber">1</span>
        <span className="t-controlContactInfo-stepLabel">{firstStepLabel}</span>
      </div>
      <div className="t-controlContactInfo-stepLine" aria-hidden="true" />
      <div className="t-controlContactInfo-step t-controlContactInfo-step--active">
        <span className="t-controlContactInfo-stepNumber">2</span>
        <span className="t-controlContactInfo-stepLabel">Onay</span>
      </div>
    </div>
  );

  renderContactHeader = (iconClass, title) => (
    <div className="t-memberInfo-cardHeader">
      <Link
        to={`/Home/ControlContactInfo/${this.props.match?.params?.id}`}
        className="t-memberDetail-headerBack"
        title="Geri Dön"
        aria-label="Geri Dön"
      >
        <i className="t-icon-arrow-left2" aria-hidden="true" />
      </Link>

      <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
        <i className={iconClass} aria-hidden="true" />
      </div>

      <div className="t-memberInfo-cardHeaderContent">
        <h2 className="t-memberInfo-cardTitle">{title}</h2>
        <div className="t-memberInfo-cardBadges">
          <span className="t-memberDetail-headerBadge">Doğrulama</span>
        </div>
      </div>
    </div>
  );

  renderVerificationMessage = () => {
    const { match, member } = this.props;
    const contactValue = member?.bilgi || this.state.bilgi;

    if (match?.params?.id === "Eposta") {
      return (
        <p className="t-updateContactInfo-message">
          Lütfen <strong>{maskEmail(contactValue)}</strong> adresine gönderilen kodu giriniz.
        </p>
      );
    }

    return (
      <p className="t-updateContactInfo-message">
        Lütfen <strong>{maskPhone(contactValue)}</strong> nolu cep telefonunuza gönderilen kodu
        giriniz.
      </p>
    );
  };

  renderVerificationForm = (firstStepLabel) => {
    const { member } = this.props;
    const { kod, isTimerExpired, canResend, isProcessing } = this.state;
    const isSubmitDisabled = isTimerExpired || isProcessing || !kod;

    return (
      <form className="t-resetPassword-form t-controlContactInfo-form" onSubmit={this.submit} noValidate>
        {this.state.formAlert ? (
          <LoginPageAlert
            messages={this.state.formAlert.messages}
            type={this.state.formAlert.type}
            onDismiss={this.clearFormAlert}
          />
        ) : null}

        <div className="t-updateContactInfo-intro">{this.renderVerificationMessage()}</div>

        <div className="t-resetPassword-field">
          <label htmlFor="kod" className="t-resetPassword-label">
            Doğrulama Kodu
          </label>
          <div className="t-resetPassword-inputWrap t-submitDemand-inputWrap t-updateContactInfo-codeWrap">
            <div>
              <i className="t-icon-phonelink_lock" aria-hidden="true" />
            </div>
            <NumberFormat
              id="kod"
              name="kod"
              type="text"
              displayType="input"
              format="######"
              placeholder="Kod"
              value={kod}
              autoComplete="off"
              disabled={isTimerExpired || isProcessing}
              onChange={(e) => {
                this.setState({ kod: e.target.value });
              }}
            />
            <div />
          </div>
        </div>

        <div className="t-updateContactInfo-timer">
          <i className="t-icon-clock" aria-hidden="true" />
          <span>Kalan süre</span>
          <Countdown
            key={member?.countDate}
            date={(member?.countDate || Date.now()) + 180000}
            renderer={(props) => (
              <strong className="t-updateContactInfo-timerValue">{Math.ceil(props.total / 1000)}</strong>
            )}
            onStart={this.handleTimerStart}
            onComplete={this.handleTimerComplete}
          />
          <span>sn</span>
        </div>

        <div className="t-resetPassword-actions t-updateContactInfo-actions">
          <button
            type="button"
            className="t-memberInfo-btn t-memberInfo-btn--secondary"
            id="tekrar_gonder"
            name="tekrar_gonder"
            disabled={!canResend || isProcessing}
            onClick={this.resetCounter}
          >
            <i className="t-icon-loop2" aria-hidden="true" />
            <span>Tekrar Gönder</span>
          </button>

          <button
            type="submit"
            className="t-memberInfo-btn t-memberInfo-btn--primary"
            id="submit"
            name="submit"
            disabled={isSubmitDisabled}
          >
            <span>Doğrula</span>
            <i className="t-icon-arrow-right2" aria-hidden="true" />
          </button>
        </div>

        {this.renderVerificationSteps(firstStepLabel)}
      </form>
    );
  };

  renderPage = (iconClass, title, firstStepLabel, subtitle) => {
    const { shouldAnimateCard, isProcessing } = this.state;

    return (
      <div style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Profilim</h1>
              <p className="t-memberInfo-pageSubtitle">{subtitle}</p>
            </div>

            <article
              className={`t-memberInfo-card t-memberDetail-header--green${
                shouldAnimateCard ? " t-memberInfo-card--enter" : ""
              }`}
            >
              {this.renderContactHeader(iconClass, title)}
              {this.renderVerificationForm(firstStepLabel)}
            </article>
          </div>
        </div>

        <div className="row" style={{ height: 30 }} />

        {isProcessing && (
          <div className="t-eminevimLoadingOverlay">
            <EminevimLoading subtext="İşleminiz gerçekleştiriliyor, lütfen bekleyiniz." compact />
          </div>
        )}
      </div>
    );
  };

  render() {
    const { match } = this.props;

    if (match?.params?.id === "Eposta") {
      return this.renderPage(
        "t-icon-lock_clock",
        "Mail Doğrulama",
        "Yeni Mail",
        "E-posta adresinize gönderilen doğrulama kodunu girerek işlemi tamamlayın."
      );
    }

    if (match?.params?.id === "Gsm") {
      return this.renderPage(
        "t-icon-lock_clock",
        "Telefon Doğrulama",
        "Yeni Tel",
        "Cep telefonunuza gönderilen doğrulama kodunu girerek işlemi tamamlayın."
      );
    }

    return null;
  }
}

const mapStateToProps = (state) => ({
  member: selectMemberInfo(state),
});

const mapDispatchToProps = (dispatch) => ({
  clearRedirect: () => dispatch(clearContactInfoRedirect()),
  saveContactInfo: (bilgi, iletisimTur, smsKod) =>
    dispatch(saveContactInfos(bilgi, iletisimTur, smsKod)),
  reSendValidateCode: (bilgi, iletisimTur) =>
    dispatch(reSendValidateCodeContactInfos(bilgi, iletisimTur)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateContactInfo);
